var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"inline-flex","color":"#fff"}},[_c('input',{ref:"input",attrs:{"type":"checkbox","disabled":_vm.disabled,"data-checked-label":_vm.activeText || _vm.text,"data-unchecked-label":_vm.inactiveText || _vm.text,"data-min-width":_vm.width,"data-max-width":_vm.width,"data-color":_vm.color}})])
}
var staticRenderFns = []

export { render, staticRenderFns }